import combinedGACall from '../combinedGACall';

export default (action, label) =>
	combinedGACall({
		category: 'Other employees',
		action,
		...(label ? { label } : null),
	});
